import type { Theme } from '../types'

import { theme as darkTheme } from './dark'
import { theme as lightTheme } from './light'

export const theme: Theme = {
  key: 'preferred',
  variables: lightTheme.variables,
  scheme: {
    light: lightTheme.variables,
    dark: darkTheme.variables,
  },
}
